import MobileServiceClient from "@mocobaas/client-js/build/MobileServiceClient";
import { ProviderBase } from "./ProviderBase";
import {
  GetListParams,
  GetListResult,
  UpdateParams,
  UpdateResult,
} from "react-admin";
import { graphqlFetch } from "../lib/graphqlClient";

const uriTest = "develop.m21-console.pages.dev";
const uriDev = "localhost:3000";

export class PaymentChannelDisplayProviderClass extends ProviderBase<any> {
  client: MobileServiceClient;

  constructor(client: MobileServiceClient) {
    super();
    this.client = client;
  }

  async update(
    resource: string,
    params: UpdateParams
  ): Promise<UpdateResult<any>> {
    try {
      const data = await graphqlFetch({
        query: `
          mutation UpdateChannelDisplayStatus($id: uuid!, $status: Boolean){
            update_payment_channel_display_by_pk(
              _set: {
                status: $status
              }
              pk_columns: {
                id: $id
              }
            ){
              channel
              country
              created_at
              id
              status
              updated_at
            }
          }
        `,
        variables: {
          id: params.id,
          status: params.data.status,
        },
      });

      return {
        data: data.update_payment_channel_display_by_pk,
      };
    } catch (error) {
      console.error(error);
      throw new Error("GraphQL mutation error");
    }
  }

  async getList(
    resource: string,
    params: GetListParams
  ): Promise<GetListResult<any>> {
    const { filter, pagination } = params;
    const where: Record<string, any> = {};

    if (filter.country) {
      where.country = { _eq: filter.country };
    }
    if (filter.status !== undefined && filter.status !== null) {
      where.status = { _eq: filter.status };
    }

    const limit = pagination.perPage;
    const offset = (pagination.page - 1) * pagination.perPage;

    try {
      const data = await graphqlFetch({
        query: `
        query GetPaymentChannelDisplay($where: payment_channel_display_bool_exp, $limit: Int, $offset: Int){
          payment_channel_display(where: $where, limit: $limit, offset: $offset, order_by: {
            created_at: desc
          }){
            channel
            country
            created_at
            id
            status
            updated_at
          }
          payment_channel_display_aggregate(where: $where) {
            aggregate {
              count
            }
          }
        }
      `,
        variables: { where, limit, offset },
      });

      return {
        data: data.payment_channel_display,
        total: data.payment_channel_display_aggregate.aggregate.count,
      };
    } catch (error) {
      console.error(error);
      throw new Error("GraphQL query error");
    }
  }
}
